module.exports = __webpack_public_path__ + "img/practice-1.f2a8822a.jpg";